import React from 'react';
import dayjs from 'dayjs'

export const timeStampTemplate = (rowData, column) => {
	return (
		<div className="flex">
			{dayjs(rowData[column.field]).format('MMMM DD, YYYY h:mm A')}
		</div>
	);
}